import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ProviderDashboard = () => {
  const { user, logout, setUser } = useAuth(); // Access global state
  const { t } = useTranslation();
  const roleKey = user?.role?.toLowerCase().trim().replace(/\s+/g, '-');
  
  return (
    <div className="max-w-7xl mx-auto px-4 py-10">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-gray-900"> {t('provider-dashboard.title')} </h1>
        {user?.role && (
            <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-xs font-bold uppercase">
                {t(`profile.${roleKey}`, { defaultValue: user.role })}
            </span>
        )}
        </div>

     <h2 className="text font-bold text-gray-400"> {t('provider-dashboard.subtitle')} </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Card 1: Listings */}
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex flex-col justify-between">
            <div>
              <h3 className="font-bold text-gray-800 text-lg">{t('provider-dashboard.card-1')}</h3>
              <p className="text-sm text-gray-500 mt-2 mb-4">{t('provider-dashboard.text-1')}</p>
            </div>
            <Link 
              to="/provider/my-listings" 
              className="block w-full text-center bg-[#ff9a45] hover:bg-[#e68a3d] text-white py-2 rounded font-semibold transition"
            >
              {t('provider-dashboard.button-1')}
            </Link>
          </div>
          
          {/* Card 2: Events */}
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex flex-col justify-between">
            <div>
              <h3 className="font-bold text-gray-800 text-lg">{t('provider-dashboard.card-2')}</h3>
              <p className="text-sm text-gray-500 mt-2 mb-4">{t('provider-dashboard.text-2')}</p>
            </div>
            <Link 
              to="/provider/manage-events"
              className="block w-full text-center bg-[#ff9a45] hover:bg-[#e68a3d] text-white py-2 rounded font-semibold transition"
            >
              {t('provider-dashboard.button-2')}
            </Link>
          </div>
        
          {/* Card 3: Analytics */}
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex flex-col justify-between">
            <div>
              <h3 className="font-bold text-gray-800 text-lg">{t('provider-dashboard.card-3')}</h3>
              <p className="text-sm text-gray-500 mt-2 mb-4">{t('provider-dashboard.text-3')}</p>
            </div>
            <Link 
              to="/provider/analytics" // <--- Added the specific analytics route
              className="block w-full text-center bg-[#ff9a45] hover:bg-[#e68a3d] text-white py-2 rounded font-semibold transition"
            >
              {t('provider-dashboard.button-3')}
            </Link>
          </div>
      </div>
    </div>
  );
};

export default ProviderDashboard;
